import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

/* eslint-disable max-params */
import Color from '@bubble-dev/fantasy-color';
import { isDarkMode, isLollipop, isPancake } from '@bubble-ui/particle-design-versions';
import * as ParticleDesignVersions from '@bubble-ui/particle-design-versions';

function logDeprecation(name, deprecation) {
  var deprecationWarning = "BUBBLE-UI DEPRECATION WARNING: color '".concat(name, "' is deprecated and will be removed");

  if (deprecation.removalDate) {
    deprecationWarning += " in/by ".concat(deprecation.removalDate);
  }

  deprecationWarning += ".";

  if (deprecation.useInstead) {
    deprecationWarning += "\nUse '".concat(deprecation.useInstead, "' instead.");
  }

  if (deprecation.readMore) {
    deprecationWarning += "\nRead more on ".concat(deprecation.readMore);
  }

  console.warn(deprecationWarning);
}

export function createInteractiveColor(defaultColor, hovered, pressed) {
  // @ts-expect-error
  var colorInteractive = new Color(defaultColor);
  colorInteractive.hovered = new Color(hovered);
  colorInteractive.pressed = new Color(pressed);
  return colorInteractive;
}
export function createInteractiveColorOf(defaultColor, hovered, pressed) {
  // @ts-expect-error
  var colorInteractive = Color.of.apply(Color, _toConsumableArray(defaultColor));
  colorInteractive.hovered = Color.of.apply(Color, _toConsumableArray(hovered));
  colorInteractive.pressed = Color.of.apply(Color, _toConsumableArray(pressed));
  return colorInteractive;
}
export var createVersionedColor = function createVersionedColor(lightColor, darkColor, lollipopColor, lollipopDarkColor, pancakeColor, pancakeDarkColor) {
  return function () {
    var designVersion = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ParticleDesignVersions.LIQUORICE;
    return isPancake(designVersion) && isDarkMode(designVersion) ? pancakeDarkColor || lollipopDarkColor || darkColor || pancakeColor || lollipopColor || lightColor : isPancake(designVersion) ? pancakeColor || lollipopColor || lightColor : isLollipop(designVersion) && isDarkMode(designVersion) ? lollipopDarkColor || darkColor || lollipopColor || lightColor : isLollipop(designVersion) ? lollipopColor || lightColor : isDarkMode(designVersion) ? darkColor || lightColor : lightColor;
  };
};
export function createVersionedColorDeprecated(name, deprecation, lightColor, darkColor, lollipopColor, lollipopDarkColor, pancakeColor, pancakeDarkColor) {
  var colorFn = createVersionedColor(lightColor, darkColor, lollipopColor, lollipopDarkColor, pancakeColor, pancakeDarkColor);
  var errorShown = false;
  return function (designVersion) {
    var _process, _process$env, _console, _process2, _process2$env;

    if ((_process = process) !== null && _process !== void 0 && (_process$env = _process.env) !== null && _process$env !== void 0 && _process$env.NODE_ENV && process.env.NODE_ENV !== 'production' && (_console = console) !== null && _console !== void 0 && _console.warn && !errorShown && ((_process2 = process) === null || _process2 === void 0 ? void 0 : (_process2$env = _process2.env) === null || _process2$env === void 0 ? void 0 : _process2$env.DISABLE_DEPRECATION_WARNINGS) !== 'yes') {
      logDeprecation(name, deprecation);
      errorShown = true;
    }

    return colorFn(designVersion);
  };
}
export var createConstantColor = function createConstantColor(color) {
  return function () {
    return color;
  };
};
export function createConstantColorDeprecated(name, deprecation, color) {
  var colorFn = createConstantColor(color);
  var errorShown = false;
  return function (designVersion) {
    var _process3, _process3$env, _console2, _process4, _process4$env;

    if ((_process3 = process) !== null && _process3 !== void 0 && (_process3$env = _process3.env) !== null && _process3$env !== void 0 && _process3$env.NODE_ENV && process.env.NODE_ENV !== 'production' && (_console2 = console) !== null && _console2 !== void 0 && _console2.warn && !errorShown && ((_process4 = process) === null || _process4 === void 0 ? void 0 : (_process4$env = _process4.env) === null || _process4$env === void 0 ? void 0 : _process4$env.DISABLE_DEPRECATION_WARNINGS) !== 'yes') {
      logDeprecation(name, deprecation);
      errorShown = true;
    }

    return colorFn(designVersion);
  };
}
export function colorVersionBuilder(liquoriceLight, liquoriceDark, lollipopLight, lollipopDark, pancakeLight, pancakeDark) {
  var defaultColor = createVersionedColor(liquoriceLight, liquoriceDark, lollipopLight.default_, lollipopDark.default_, pancakeLight.default_, pancakeDark.default_);
  var hoveredColor = createVersionedColor(liquoriceLight.hovered, liquoriceDark.hovered, lollipopLight.hovered, lollipopDark.hovered, pancakeLight.hovered, pancakeDark.hovered);
  var pressedColor = createVersionedColor(liquoriceLight.pressed, liquoriceDark.pressed, lollipopLight.pressed, lollipopDark.pressed, pancakeLight.pressed, pancakeDark.pressed);
  return [defaultColor, hoveredColor, pressedColor];
}
export function colorVersionBuilderDeprecated(names, deprecation, liquoriceLight, liquoriceDark, lollipopLight, lollipopDark, pancakeLight, pancakeDark) {
  var defaultColor = createVersionedColorDeprecated(names[0], deprecation, liquoriceLight, liquoriceDark, lollipopLight.default_, lollipopDark.default_, pancakeLight.default_, pancakeDark.default_);
  var hoveredColor = createVersionedColorDeprecated(names[1], deprecation, liquoriceLight.hovered, liquoriceDark.hovered, lollipopLight.hovered, lollipopDark.hovered, pancakeLight.hovered, pancakeDark.hovered);
  var pressedColor = createVersionedColorDeprecated(names[2], deprecation, liquoriceLight.pressed, liquoriceDark.pressed, lollipopLight.pressed, lollipopDark.pressed, pancakeLight.pressed, pancakeDark.pressed);
  return [defaultColor, hoveredColor, pressedColor];
}
//# sourceMappingURL=helpers.js.map